import React, { PureComponent, useEffect, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Box, withWidth, withStyles } from "@material-ui/core";
import style from './styles.module.scss';
import SecondaryNav from './../components/SecondaryNav';
import SingleAndParcelsTabs, { StyledLinearProgress } from './../components/SingleAndParcelsTabs';
import IconButton from '@material-ui/core/IconButton';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as AuthActions from "./../../../../redux/actions/auth";
import * as DiamondsActions from "./../../../../redux/actions/diamonds";
import Button from '@material-ui/core/Button';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import RadioButtonUncheckedOutlinedIcon from '@material-ui/icons/RadioButtonUncheckedOutlined';
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Switch from '@material-ui/core/Switch';
import { makeStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';
import Tooltip from '@material-ui/core/Tooltip';
import ConditionalWrapper from './../../../../shared/components/ConditionalWrapper';
import renderStringOrComponent from './../../../../shared/functions/renderStringOrComponent';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Collapse from '@material-ui/core/Collapse';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { Link } from 'react-router-dom';
import numeral from 'numeral';
import Fade from '@material-ui/core/Fade';
import DiamondRowDetails from './../components/DiamondRowDetails';
import NumberFormat from "react-number-format";
import _ from 'lodash';
//  https://www.npmjs.com/package/material-ui-search-bar
import SearchBar from "material-ui-search-bar";
import styled, { createGlobalStyle } from 'styled-components';
import getSymbolFromCurrency from 'currency-symbol-map';
import { convertToCurrency } from 'shared/functions/priceCalc';
import PDFDocument from './PdfDocument';
import { pdf, PDFViewer } from '@react-pdf/renderer';
import { saveAs } from 'file-saver';
import moment from 'moment';

import ExcelJS from 'exceljs';

import MessageDialog from "./../../dialog/MessageDialog";

import { Checkboxes } from 'mui-rff';
import api from 'shared/functions/api/';

import { valuesMapAvailability } from 'logged_in_admin/components/dashboard/DiamondsAvailabilitySettings';

const CheckboxesSmallWrap = styled.div`
.MuiTypography-body1{ 
  font-size: 12px;
}
.MuiFormControlLabel-root{
    margin: 0;
}`;

const HideTrengoChat = createGlobalStyle`
#trengo-web-widget{
  display: none !important;
}
`;

const StyledSearchBar = styled(SearchBar)`
    padding: 10px;
    padding-top: 0;
    padding-bottom: 0;
    min-width: 250px;
    float: right;
    width: 30%;
    height: 40px;
    
    input{
      font-family: Lato;
      font-size: 15px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.2;
      letter-spacing: normal;
      text-align: left;
      color: #b6b8bc;
    }
    button{
      color: #7f8489;
      padding-right: 6px;
    }
    & > div{
      margin-left: 0;
      margin-right: auto;
      width: auto;
    }
    svg{
      height: 17px;
    }
`;

const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: "rect(0 0 0 0)",
        height: 1,
        margin: -1,
        overflow: "hidden",
        padding: 0,
        position: "absolute",
        top: 20,
        width: 1
    },
    tableHeadRow: {
        '& > *': {
            border: 'solid 1px #edeeee',
            borderLeft: 'none',
            borderRight: 'none',
            paddingTop: 6,
            paddingBottom: 6,
            fontFamily: 'Lato',
            fontSize: 12,
            background: 'white',
            paddingLeft: 10,
            paddingRight: 10,
        },
    },
    tableRow: {
        '& > *': {
            borderBottom: 'unset',
            padding: 16,
            [theme.breakpoints.down("xs")]: {
                padding: 8
            }
        },
    },
    tableRowOpen: {
        backgroundColor: '#F7F6F5',
    },
    tableRowHover: {
        '&.MuiTableRow-hover:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.02)',
        },
    },
    tableCellActions: {
        display: 'inline-flex',
        gap: '15px',
        alignContent: 'center',
        '& .emptyAction': {
            width: 30
        },
        '& svg': {
            color: '#B08F6E',
            width: 16,
        },
        width: 144
    },
}));

const shapesSingle = [
    { label: 'Round', value: 'round' },
    { label: 'Marquise', value: 'marquise' },
    { label: 'Emerald', value: 'emerald' },
    { label: 'Radiant', value: 'radiant' },
    { label: 'Pear', value: 'pear' },
    { label: 'Princess', value: 'princess' },
    { label: 'Oval', value: 'oval' },
    { label: 'Trilliant', value: 'trilliant' },
    { label: 'Heart', value: 'heart' },
    { label: 'Asscher', value: 'asscher' },
    { label: 'Cushion', value: 'cushion' },
    { label: 'Other', value: 'other' },
];

const shapesParcels = [
    { label: 'Round', value: 'round' },
    { label: 'Princess', value: 'princess' },
    { label: 'Emerald', value: 'emerald' },
    { label: 'Radiant', value: 'radiant' },
    { label: 'Asscher', value: 'asscher' },
    { label: 'Cushion', value: 'cushion' },
    { label: 'Pear', value: 'pear' },
    { label: 'Oval', value: 'oval' },
    { label: 'Marquise', value: 'marquise' },
    { label: 'Heart', value: 'heart' },
    { label: 'Baguette', value: 'baguette' },
    { label: 'Tapered', value: 'tapered' },
    { label: 'Old Cuts', value: 'old cut,european cut' },
    { label: 'Trilliant', value: 'trilliant' },
    { label: 'Trapezoid', value: 'trapezoid' },
    { label: 'Other', value: 'other' },
];

export function isOtherShape(isParcel, StkShape) {
    const shapesValues = (!isParcel ? shapesSingle : shapesParcels).map(s => s.value.split(',')).flat();
    return !shapesValues.includes(StkShape.toLowerCase());
}

const TableHeadCellActions = ({ tableMode, onTableModeClick, onDownloadClick, isDownloadView, isSearchView, onSearchClick, wrapStyle, isMobile }) => {
    const classes = useStyles();
    return <div className={classes.tableCellActions} style={wrapStyle}>
        {isMobile && <Tooltip title={'Search'} placement="top">
            <IconButton size="small" onClick={() => onSearchClick()}>
                <img alt="" src={`/images/search${isSearchView ? '_active' : ''}.svg`} style={{ filter: isSearchView && 'brightness(0)' }} />
            </IconButton>
        </Tooltip>}
        <Tooltip title={'Download View'} placement="top">
            <IconButton size="small" onClick={() => onDownloadClick()}>
                <img alt="" src={`/images/download${!isDownloadView ? '_default' : '_active'}_icon.svg`} />
            </IconButton>
        </Tooltip>
        {/* 
        <Tooltip title={'Grid View'} placement="top">
            <IconButton size="small" onClick={() => onTableModeClick('mosaic')}>
                <img alt="" src={`/images/mosaic${tableMode !== 'mosaic' ? '' : '_active'}.svg`} />
            </IconButton>
        </Tooltip> 
        <Tooltip title={'List View'} placement="top">
            <IconButton size="small" onClick={() => onTableModeClick('list')}>
                <img alt="" src={`/images/list${tableMode !== 'list' ? '' : '_active'}.svg`} />
            </IconButton>
        </Tooltip>
        */}
    </div>;
}

const TableRowCellActions = ({ open, setOpen, isShown, isFav, toggleFav, isCompare, toggleCompare, isDownloadView, toggleDownloadItem, isDownloadItem, isMobile }) => {
    const classes = useStyles();

    if (isDownloadView) {
        return <div className={classes.tableCellActions}>
            <div>
                <Checkbox
                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                    name="checkedI"
                    onChange={(e, value) => toggleDownloadItem(value)}
                    checked={isDownloadItem}
                    onClick={e => e.stopPropagation()}
                />
            </div>
            <div className="emptyAction"></div>
            <div className="emptyAction"></div>
        </div>;
    }

    return !isShown && !isMobile ? '' : <div className={classes.tableCellActions}>
        <Tooltip title={`${!isDownloadItem ? 'Add to' : 'Remove from'} Download`}>
            <Checkbox
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                name="checkedI"
                onChange={(e, value) => toggleDownloadItem(value)}
                checked={isDownloadItem}
                onClick={e => e.stopPropagation()}
            />
        </Tooltip>
        <Tooltip title={`${!isFav ? 'Add to' : 'Remove from'} Favourites`}>
            <IconButton size="small" onClick={(e) => { e.stopPropagation(); toggleFav(!isFav); }} className={(!isFav && style.hoverSwitch) || undefined}>
                {!isFav && <React.Fragment>
                    <img alt="" src="/images/fav.svg" />
                    <img alt="" className={style.hover} src="/images/fav_hover.svg" />
                </React.Fragment>}
                {isFav && <img alt="" src="/images/fav_active.svg" />}
            </IconButton>
        </Tooltip>
        <Tooltip title={`${!isCompare ? 'Add to' : 'Remove from'} Compare`}>
            <IconButton size="small" onClick={(e) => { e.stopPropagation(); toggleCompare(!isCompare); }} className={(!isCompare && style.hoverSwitch) || undefined} style={{ paddingTop: 6 }}>
                {!isCompare && <React.Fragment>
                    <img alt="" src="/images/compare.svg" />
                    <img alt="" className={style.hover} src="/images/compare_hover.svg" />
                </React.Fragment>}
                {isCompare && <img alt="" src="/images/compare_active.svg" />}
            </IconButton>
        </Tooltip>
        <IconButton size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </IconButton>
    </div>;
}

const headCells = ({ isParcel, isAuthorised, showExtraColumns = {}, ccy, fxrates = [], diamond_available = {}, isMobile }) => {

    let cols = [
        { name: "StkShape", title: !isMobile ? "" : "Shape", align: isMobile ? 'center' : 'right', numeric: false, width: 35, getCellValue: row => <Link to={`/diamonds/${row._id}/details`}><img alt="" src={row.img} width="35" /></Link>, sort: isMobile },
    ];

    if (!isMobile) {
        cols.push({ name: "StkShape", title: "Shape", numeric: false, align: 'left' });
    }

    cols = [...cols,
    { name: isParcel ? "size" : "weight", title: isParcel ? "Size" : "Weight", numeric: !isMobile ? true : false, getCellValue: row => row.isParcel ? row.size || '-' : `${numeral(row.STWeight).format('0.00')}ct` },
    { name: "colour", title: "Colour", numeric: false, getCellValue: row => row.colour || '-' }
    ];

    if (!isMobile || (isMobile && !isParcel)) {
        cols.push({ name: "clarity", title: "Clarity", numeric: false, getCellValue: row => row.clarity || '-' })
    }

    if (isMobile) {
        if (isAuthorised) {
            if (!isParcel) {
                cols.push({
                    name: "price", title: "Price", numeric: true, getCellValue: row =>
                        <div className={(classNames(row.open && style.openPrice)) || undefined}>
                            {getSymbolFromCurrency(ccy)}{numeral(Math.round(convertToCurrency(row.price, false, fxrates, ccy))).format('0,0.00')}
                        </div>
                });
                cols.push({
                    name: "ppc", title: "PPC", numeric: true, getCellValue: row =>
                        <div>
                            {getSymbolFromCurrency(ccy)}{numeral(Math.round(convertToCurrency(row.ppcOrig, false, fxrates, ccy))).format('0,0.00')}
                        </div>
                });
            }
            if (isParcel) {
                cols.push({
                    name: "ppc", title: "PPC", numeric: true, getCellValue: row =>
                        <div className={(classNames(row.open && style.openPrice)) || undefined}>
                            {getSymbolFromCurrency(ccy)}{numeral(Math.round(convertToCurrency(row.ppc, true, fxrates, ccy))).format('0,0.00')}
                        </div>
                });
            }
        }

        if (isParcel) {
            cols.push({ name: "clarity", title: "Clarity", numeric: false, getCellValue: row => row.clarity || '-' })
        }
    }

    if (!isParcel) {
        cols.push({
            name: "StkCertSup", title: "Lab", numeric: false
        })
    }

    if (showExtraColumns.availability && isAuthorised) {
        cols.push({
            name: "availability", title: "Availability", numeric: false, getCellValue: row =>
                <div className={(row.availability === 1 && style.availability) || undefined}>
                    {row.availability === 1 ? (diamond_available['diamond_available_now'] || valuesMapAvailability['1']) : ''}
                    {row.availability === 2 ? (diamond_available['diamond_available_later'] || valuesMapAvailability['2']) : ''}
                    {row.availability === 3 ? (diamond_available['diamond_available_on_demand'] || valuesMapAvailability['3']) : ''}
                </div>
        })
    }

    if (!isMobile) {
        if (isAuthorised) {
            if (!isParcel) {
                cols.push({
                    name: "ppc", title: "PPC", align: 'center', numeric: false, getCellValue: row =>
                        <div>
                            {getSymbolFromCurrency(ccy)}{numeral(Math.round(convertToCurrency(row.ppcOrig, false, fxrates, ccy))).format('0,0.00')}
                        </div>
                });
                cols.push({
                    name: "price", title: "Price", align: 'center', numeric: false, getCellValue: row =>
                        <div className={(classNames(row.open && style.openPrice)) || undefined}>
                            {getSymbolFromCurrency(ccy)}{numeral(Math.round(convertToCurrency(row.price, false, fxrates, ccy))).format('0,0.00')}
                        </div>
                });
            }
        }
    }

    if (showExtraColumns.cut) {
        cols.push({
            name: "cut", title: "Cut"
        });
    }

    if (showExtraColumns.polish) {
        cols.push({
            name: "polish", title: "Polish"
        });
    }

    if (showExtraColumns.symmetry) {
        cols.push({
            name: "symmetry", title: "Symmetry"
        });
    }

    if (showExtraColumns.fluorescence) {
        cols.push({
            // this is spelt wrong on purpose - we thought it's funny!
            name: "flourecence", title: "Fluorescence"
        });
    }

    if (showExtraColumns.depth) {
        cols.push({
            name: "StkDepth_Total", title: "Depth", getCellValue: row => row.StkDepth_Total ? row.StkDepth_Total + '%' : '-'
        });
    }

    if (showExtraColumns.table) {
        cols.push({
            name: "StkTable", title: "Table", getCellValue: row => row.StkTable + '%'
        });
    }

    if (showExtraColumns.measurements) {
        cols.push({
            name: "Stk_Mes_Concat", title: "Measurements"
        });
    }

    if (!isMobile) {
        if (isAuthorised) {
            if (isParcel) {
                cols.push({
                    name: "ppc", title: "PPC", numeric: true, getCellValue: row =>
                        <div className={(classNames(row.open && style.openPrice)) || undefined}>
                            {getSymbolFromCurrency(ccy)}{numeral(Math.round(convertToCurrency(row.ppc, true, fxrates, ccy))).format('0,0.00')}
                        </div>
                });
            }
        }
    }

    if (showExtraColumns.lengthWidthRatio) {
        cols.push({
            name: "lengthWidthRatio", title: "L / W", getCellValue: row => numeral((row.StkMes1 / row.StkMes2)).format('0.00')
        });
    }

    if (showExtraColumns.rap && isAuthorised) {
        cols.push({
            name: "RAP", title: "RAP", getCellValue: row => row.RAP + '%'
        });
    }

    if (showExtraColumns.sieve) {
        cols.push({
            name: "sieve", title: "Sieve Plate", getCellValue: row => row.sieve || '-'
        });
    }

    cols.push({
        name: "specialOffer", 
        title: <Tooltip title={'Special Offers'} placement="top"><img style={{width: 18, verticalAlign: 'middle'}} alt="" src={`/images/special-offer-icon-col.svg`} /></Tooltip>, 
        getCellValue: row => row.specialOffer ? <Tooltip title={'Special Offer'} placement="top"><img style={{width: 18}} alt="" src={`/images/special-offer-icon-row.svg`} /></Tooltip> : '',
    });

    cols.push({
        name: "actions",
        title: ({ tableMode, onTableModeClick, onDownloadClick, isDownloadView, isSearchView, onSearchClick }) =>
            !isMobile ? <TableHeadCellActions
                tableMode={tableMode}
                onTableModeClick={onTableModeClick}
                onDownloadClick={onDownloadClick}
                isDownloadView={isDownloadView}
                isSearchView={isSearchView}
                onSearchClick={onSearchClick}
            /> : <div style={{ width: 130 }}></div>,
        getCellValue: row =>
            <TableRowCellActions
                open={row.open}
                setOpen={row.setOpen}
                isShown={row.isShown}
                isFav={row.isFav}
                toggleFav={row.toggleFav}
                toggleCompare={row.toggleCompare}
                isCompare={row.isCompare}
                isDownloadItem={row.isDownloadItem}
                isDownloadView={row.isDownloadView}
                toggleDownloadItem={row.toggleDownloadItem}
                isMobile={isMobile}
            />,
        numeric: false,
        sort: false,
        align: 'right'
    });

    return cols;
}

function CustomRow({ row, index, isAuthorised, openBag, isParcel, columnsSetup, ccy, fxrates = [], open360MessageDialog, openEmailDialog, isMobile, id }) {
    const classes = useStyles();
    const [isShown, setIsShown] = React.useState(false);
    const open = row.open;
    const setOpen = row.setOpen;
    row.isShown = open || isShown;
    row.isParcel = isParcel;
    return <React.Fragment>
        {!open && <TableRow className={classNames(classes.tableRow, !open && classes.tableRowHover, open && classes.tableRowOpen)} hover={!open} tabIndex={-1} key={row.name} onMouseEnter={() => setIsShown(true)} onMouseLeave={() => setIsShown(false)} onClick={(e) => !open ? setOpen(true) : undefined}>
            {columnsSetup.map((col, index) => (
                <TableCell key={col.name} {...(index === 0 ? { component: "th", scope: "row" } : {})} align={col.numeric ? "right" : col.align || "center"}>
                    <div className={style.cellText} style={{ display: open && (!isMobile ? index < (isParcel ? 6 : 8) : true) ? 'none' : 'block' }}>
                        {(col.getCellValue && col.getCellValue(row, index)) || row[col.name]}
                    </div>
                </TableCell>
            ))}
        </TableRow>}
        <TableRow className={classNames(classes.tableRow, open && classes.tableRowOpen)} id={id}>
            <TableCell style={{ paddingBottom: 0, paddingTop: open ? 30 : 0 }} colSpan={6}>
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <Fade in={open} timeout={{ enter: 2000 }}>
                        <Box margin={1} position="relative" marginTop={2}>
                            <DiamondRowDetails isAuthorised={isAuthorised} openBag={openBag} row={row} isParcel={isParcel} ccy={ccy} fxrates={fxrates} open360MessageDialog={() => open360MessageDialog()} openEmailDialog={openEmailDialog} setOpen={setOpen} toggleCompare={row.toggleCompare} isCompare={row.isCompare} toggleFav={row.toggleFav} isFav={row.isFav} />
                        </Box>
                    </Fade>
                </Collapse>
            </TableCell>
            {open && <React.Fragment>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
            </React.Fragment>}
        </TableRow>
    </React.Fragment>;
}

function parseHenigArray(d, field) {
    return [d[field][0] && d[field][0].From, d[field][1] && d[field][1].To].filter(s => s)
}

function joinHenigArray(d, field) {
    return parseHenigArray(d, field).join(' to ')
}

function EnhancedTable({
    tabsValue,
    isParcel,
    fetchDiamondsList,
    docs,
    docsLength,
    favouriteItemsList,
    compareItemsList,
    toggleFav,
    toggleCompare,
    onDownloadClick,
    isDownloadView,
    toggleDownloadItem,
    downloadItemsList,
    isAuthorised,
    openBag,
    columnsSetup,
    page=1, setPage, limit, order='asc', orderBy='createdAt', 
    isLoading,
    anyFiltersInUse,
    isSearchView,
    onSearchClick,
    ccy,
    fxrates = [],
    open360MessageDialog,
    openEmailDialog,
    isMobile,
    openRowIndex=-1, 
    setOpenRowIndex,
    isPC,
}) {

    if(!limit){
        limit = isPC ? 100 : 25;
    }

    const classes = useStyles();
    const [rowsOrder, setOrder] = React.useState(order);
    const [rowOrderBy, setOrderBy] = React.useState(orderBy);
    const [rowsPerPage, setRowsPerPage] = React.useState(limit);
    const [tableMode, setTableMode] = React.useState('list');
    const [diamondDataDocs, setDiamondDataDocs] = useState([]);
    const [rows, setRows] = useState([]);

    const handleRequestSort = (event, property) => {
        const isAsc = rowOrderBy === property && rowsOrder === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };

    const handleChangePage = (event, newPage) => {
        setOpenRowIndex(-1);
        setPage(newPage + 1);
    }

    const setOpen = (value, index, id) => {
        if (!value) {
            setOpenRowIndex(-1);
        } else {
            setOpenRowIndex(index);

            setTimeout(() => {
                const container = document.getElementById("tableScrollableContainer");
                const containerPos = (container ? container.offsetTop : 0) + 50

                const element = document.getElementById(id);
                const position = element && element.getBoundingClientRect().top || 0;
                
                if(container){
                    container.scrollBy({top: position - containerPos, behavior: "smooth"})
                }
            }, 500)

        }
    }

    const handleChangeRowsPerPage = (event) => {
        setOpenRowIndex(-1);
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(1);
    };

    //const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage); //without server pagination
    //const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length); // with server pagination
    const emptyRows = 0;

    const createSortHandler = (property) => (event) => handleRequestSort(event, property);

    useEffect(() => {
        const fetchDiamondsListAsync = async () => {
            await fetchDiamondsList(rowsPerPage, rowsOrder, rowOrderBy);
        }
        fetchDiamondsListAsync();    
    }, [fetchDiamondsList, rowsPerPage, rowsOrder, rowOrderBy, isParcel, tabsValue]);


    useEffect(() => {
        if (docs !== diamondDataDocs) {

            setDiamondDataDocs(docs);

            setRows(docs.map((d, index) => ({
                ...{
                    ...d,
                    img: `/images/${isOtherShape(isParcel, d.StkShape) ? 'round' : d.StkShape.toLowerCase()}${isParcel ? '_parcel.png' : '.png'}`,
                    colour: joinHenigArray(d, 'Colour'),
                    clarity: joinHenigArray(d, 'Clarity'),
                    cut: joinHenigArray(d, 'Cut'),
                    flourecence: joinHenigArray(d, 'flourecence'),
                    symmetry: joinHenigArray(d, 'Symmetry'),
                    polish: joinHenigArray(d, 'Polish'),
                    size: joinHenigArray(d, 'Size'),
                    availability: d.Availability || d.StkWebAvailable,
                    price: d.WebSpecial || d.price || d.ExWebTotal,
                    ppc: d.WebSpecial || d.ppc || d.ExWebTotal,
                    specialOffer: d.WebSpecial ? true : false,
                    sieve: joinHenigArray(d, 'Sieve'),
                },
            })))
        }
    }, [setDiamondDataDocs, diamondDataDocs, docs]);

    return <div style={{width: isDownloadView ? 'calc(100% - 160px)' : '100%'}}>
        <TableContainer id="tableScrollableContainer">
            <Table stickyHeader className={classes.table} size={"medium"} style={{ opacity: isLoading ? 0.5 : 1 }}>
                <TableHead>
                    <TableRow className={classes.tableHeadRow}>
                        {columnsSetup.map((col, i) => (
                            <TableCell key={col.name} align={col.numeric ? "right" : col.align || "center"} sortDirection={rowOrderBy === col.name ? rowsOrder : false} style={{ width: col.width, paddingRight: !isMobile && col.numeric ? 18 : 10}} className={`${col.name}-headCell`}>
                                <ConditionalWrapper
                                    condition={col.sort !== false}
                                    wrapper={children => <TableSortLabel active={rowOrderBy === col.name} direction={rowOrderBy === col.name ? rowsOrder : "asc"} onClick={createSortHandler(col.name)}>{children}</TableSortLabel>}
                                >
                                    <ConditionalWrapper
                                        condition={((!col.numeric && !col.align) || (!col.numeric && col.align === 'center'))}
                                        wrapper={children => <div style={!isMobile ? { paddingLeft: 26, whiteSpace: 'nowrap' } : i === 0 ? { paddingLeft: 0 } : { paddingLeft: 10, paddingRight: col.numeric ? 10 : 25, marginRight: -19, whiteSpace: 'nowrap' }}>{children}</div>}
                                    >
                                        {renderStringOrComponent(col.title, { tableMode, onTableModeClick: value => setTableMode(value), onDownloadClick, isDownloadView, isSearchView, onSearchClick })}
                                    </ConditionalWrapper>

                                    {rowOrderBy === col.name ? (
                                        <span className={classes.visuallyHidden}>
                                            {rowsOrder === "desc" ? "sorted descending" : "sorted ascending"}
                                        </span>
                                    ) : null}
                                </ConditionalWrapper>
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row, index) => <CustomRow
                        key={row._id}
                        id={row._id}
                        columnsSetup={columnsSetup}
                        row={{
                            ...row,
                            isFav: favouriteItemsList.find(f => f._id === row._id),
                            isCompare: compareItemsList.includes(row._id),
                            toggleFav: value => toggleFav(row, value),
                            toggleCompare: value => toggleCompare(row._id, value),
                            isDownloadView,
                            toggleDownloadItem: value => toggleDownloadItem(row._id, value),
                            isDownloadItem: downloadItemsList.includes(row._id),
                            open: openRowIndex === index,
                            setOpen: (value) => setOpen(value, index, row._id),
                        }}
                        isParcel={isParcel}
                        index={index}
                        isAuthorised={isAuthorised}
                        openBag={openBag}
                        ccy={ccy}
                        fxrates={fxrates}
                        open360MessageDialog={() => open360MessageDialog()}
                        openEmailDialog={openEmailDialog}
                        isMobile={isMobile}
                    />)}
                    {emptyRows > 0 &&
                        <TableRow style={{ height: 53 * emptyRows }}>
                            <TableCell colSpan={6} />
                        </TableRow>
                    }
                </TableBody>
            </Table>
            {docsLength === 0 && !isLoading &&
                <div className={style.emptyListMsg}>
                    <h2>No Results Found</h2>
                    <h3>
                        Change Your Criteria<br />
                            Using The Filters In The Side Column
                        </h3>
                </div>
            }
        </TableContainer>
        {!(isLoading && rows.length === 0) &&
            <TablePagination
                style={{ display: 'flex', justifyContent: 'center' }}
                rowsPerPageOptions={[/* 10, */ 25, 50, 100 /* , { value: -1, label: "All" } */]}
                component="div"
                count={anyFiltersInUse ? docsLength : -1}
                labelDisplayedRows={({ from, to, count }) => `${from}-${to} ${count !== -1 ? `of ${count}` : ''}`}
                rowsPerPage={rowsPerPage}
                page={page - 1}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
            />
        }
    </div>;
}

function valuetext(value) {
    return `${value}°C`;
}

const marksVotes = [
    {
        value: 0,
        label: 'Excellent',
    },
    {
        value: 25,
        label: 'Very Good',
    },
    {
        value: 50,
        label: 'Good',
    },
    {
        value: 75,
        label: 'Fair',
    },
    {
        value: 100,
        label: 'Poor',
    },
];
const marksVotesMap = {
    0: 5,
    25: 4,
    50: 3,
    75: 2,
    100: 1,
};

const marksFluorescence = [
    {
        value: 0,
        label: 'None',
    },
    {
        value: 25,
        label: 'Faint',
    },
    {
        value: 60,
        label: 'Slight',
    },
    {
        value: 95,
        label: 'Medium',
    },
    {
        value: 125,
        label: 'V. Slight',
    },
    {
        value: 155,
        label: 'Strong',
    },
    {
        value: 195,
        label: 'V. Strong',
    },
];
const marksFluorescenceMap = {
    0: 1,
    25: 2,
    60: 3,
    95: 4,
    125: 5,
    155: 6,
    195: 7,
};

const sliderStyles = makeStyles({
    root: {
        width: 300,
        paddingTop: 40,
        marginBottom: 0,
    },
    mark: {
        height: 4,
        width: 3,
        backgroundColor: '#846b53',
    },
    markActive: {
        backgroundColor: 'white',
    },
    markLabel: {
        marginTop: -20,
        color: '#846b53',
    },
    markLabelPrice: {
        marginTop: -10,
    },
    markLabelActive: {
        color: '#b08f6e',
    },
    valueLabel: {
        fontSize: 9,
        textAlign: 'center',
    },
    track: {
        backgroundColor: '#b08f6e',
        height: 4,
    },
    thumb: {
        backgroundColor: '#fff',
        boxShadow: '0 2px 4px 0 #777',
    },
    sliderWrapWithInputs: {
        paddingBottom: 10,
        '& .MuiSlider-root': {
            padding: 0,
        }
    },
    sliderInput: {
        width: 160,

        '& .MuiInput-underline:before': {
            borderBottom: '1px solid #8d9298'
        },
        '& .MuiInput-underline:after': {
            borderBottom: '2px solid #8d9298'
        },
        '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
            borderBottom: '2px solid #8d9298'
        },
    },
    sliderInputLarge: {
        '& input': {
            fontSize: '13px !important',
            color: '#b08f6e !important',
            fontWeight: '600 !important',
        }
    },
});

const optionsInputCarats = (defaultRanges) => ({
    defaultValue: defaultRanges[0],
    defaultMaxValue: defaultRanges[1],
    InputProps: {
        startAdornment: <InputAdornment position="start">–</InputAdornment>,
        endAdornment: <InputAdornment position="end">ct</InputAdornment>,
        inputComponent: NumberFormatCustom,
    }
});

const optionsInputPercentage = {
    defaultValue: "0",
    defaultMaxValue: "100",
    InputProps: {
        endAdornment: <InputAdornment position="end">%</InputAdornment>,
    }
};

const optionsInputMeasurements = (defaultRanges) => ({
    defaultValue: defaultRanges[0],
    defaultMaxValue: defaultRanges[1],
    InputProps: {
        startAdornment: <InputAdornment position="start">–</InputAdornment>,
        endAdornment: <InputAdornment position="end">mm</InputAdornment>,
        inputComponent: NumberFormatCustom,
    }
});

const optionsInputPrice = (defaultRanges) => ({
    defaultValue: defaultRanges[0],
    defaultMaxValue: defaultRanges[1],
    InputProps: {
        startAdornment: <InputAdornment position="start">$</InputAdornment>,
        inputComponent: NumberFormatCustom,
    }
});

function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value
                    }
                });
            }}
            thousandSeparator
        // isNumericString
        />
    );
}

const priceMarks = [
    {
        value: 0,
        scaledValue: 1,
        label: "1"
    },
    {
        value: 80,
        scaledValue: 5000,
        label: "5k"
    },
    {
        value: 100,
        scaledValue: 50000,
        label: "50k>"
    }
];

const priceScale = values => {
    if (!Array.isArray(values)) {
        values = [values];
    }
    const result = [];
    for (let value of values) {

        let previousMarkIndex = Math.max(0, priceMarks.findIndex((a, i) => a.value > value && a.value <= priceMarks[(i === priceMarks.length - 1 ? i : i + 1)].value) - 1);
        if (value === priceMarks[priceMarks.length - 1].value) {
            previousMarkIndex = priceMarks.length - 1;
        }

        const previousMark = priceMarks[previousMarkIndex];

        const difference = priceMarks[previousMarkIndex === priceMarks.length - 1 ? priceMarks.length - 2 : previousMarkIndex + 1].value - priceMarks[previousMarkIndex].value;

        const remainder = value % difference;
        if (remainder === 0) {
            result.push(previousMark.scaledValue);
        } else {
            const nextMark = priceMarks[previousMarkIndex + 1];
            const increment = (nextMark.scaledValue - previousMark.scaledValue) / difference;
            result.push(remainder * increment + previousMark.scaledValue);
        }
    }
    return result;
};

function numFormatter(num, ccy) {
    if (num > 999 && num < 1000000) {
        if (num < 10000) {
            return getSymbolFromCurrency(ccy) + numeral(num / 1000).format('0.0') + "K";
        } else {
            return getSymbolFromCurrency(ccy) + numeral(num / 1000).format('0') + "K";
        }
    } else if (num >= 1000000) {
        return getSymbolFromCurrency(ccy) + numeral(num / 1000000).format('0.0') + "M";
    } else if (num < 999) {
        return getSymbolFromCurrency(ccy) + numeral(num).format('0');
    }
}


function ValueLabelComponent(props) {
    const { children, open, value } = props;

    return (
        <Tooltip open={open} enterTouchDelay={0} placement="top" title={value}>
            {children}
        </Tooltip>
    );
}


function HenigSliderPrice({ value, onChange, ccy }) {
    const classes = sliderStyles();
    const [val, setVal] = React.useState(value)

    React.useEffect(() => {
        setVal(value);
    }, [value]);

    return (<React.Fragment>
        <div className={classNames(style.sliderWrap)}>
            <Slider
                ValueLabelComponent={ValueLabelComponent}
                classes={{
                    root: classes.root,
                    markLabel: classNames(classes.markLabel, style.sliderMarkLabel, classes.markLabelPrice),
                    mark: classes.mark,
                    track: classes.track,
                    thumb: classes.thumb,
                    markActive: classes.markActive,
                    markLabelActive: classes.markLabelActive,
                    valueLabel: classes.valueLabel,
                }}
                onChange={(e, value) => onChange(value)}
                getAriaValueText={valuetext}
                step={1}
                min={0}
                max={100}
                value={val}
                marks={priceMarks.map(p => ({
                    ...p,
                    label: getSymbolFromCurrency(ccy) + p.label,
                }))}
                scale={priceScale}
                valueLabelFormat={num => numFormatter(num, ccy)}
                valueLabelDisplay="auto"
            />
        </div>
    </React.Fragment>
    );
}


function HenigSliderLarge({ marks, min, max, step, value, onChange, inputs, optionsInput, wrapperStyle = {} }) {
    const classes = sliderStyles();

    const defaultMinVal = optionsInput && optionsInput.defaultValue;
    const defaultMaxVal = optionsInput && (optionsInput.defaultMaxValue || optionsInput.defaultValue);
    const [minVal, setMinVal] = React.useState(defaultMinVal)
    const [maxVal, setMaxVal] = React.useState(defaultMaxVal)
    const [val, setVal] = React.useState(value)

    React.useEffect(() => {
        setVal(value);
        setMinVal(value[0])
        setMaxVal(value[1])
    }, [value]);

    const updateMinValueFromInput = (minVal) => {
        if (!minVal) return minVal;
        minVal = parseFloat((minVal > defaultMinVal && minVal) || defaultMinVal);
        setMinVal(minVal);
        onChange([minVal, maxVal]);
    }

    const updateMaxValueFromInput = (maxVal) => {
        if (!maxVal) return maxVal;
        maxVal = parseFloat((maxVal < defaultMaxVal && maxVal) || defaultMaxVal);
        setMaxVal(maxVal);
        onChange([minVal, maxVal]);
    }

    const handleFocus = event => {
        event.preventDefault();
        const { target } = event;
        setTimeout(() => {
            target.focus();
            if(target.value){
                target.setSelectionRange(0, target.value.length);
            }
        }, 200)
    }

    const intputStyle = {
        height: 34,
        border: '1px solid rgb(141, 146, 152)',
        padding: 8,
        borderBottom: '3px solid rgb(176, 143, 110)',
        background: '#444952',
        paddingTop: 2,
        marginTop: 8,
    }

    return (<React.Fragment>
        {inputs && <div className={classNames(style.sliderWrap, inputs && classes.sliderWrapWithInputs)} style={{...wrapperStyle, gap: 80}}>
            <TextField
                classes={{ root: classNames(classes.sliderInput, style.sliderInput, classes.sliderInputLarge) }}
                {...optionsInput}
                value={minVal}
                onChange={e => updateMinValueFromInput(parseFloat(e.target.value))}
                onFocus={handleFocus}
                onClick={handleFocus}
                style={intputStyle}
                InputProps={{...optionsInput.InputProps, disableUnderline: true, startAdornment: 'From'}}
            />
            <TextField
                classes={{ root: classNames(classes.sliderInput, style.sliderInput, classes.sliderInputLarge) }}
                {...optionsInput}
                value={maxVal}
                onChange={e => updateMaxValueFromInput(parseFloat(e.target.value))}
                onFocus={handleFocus}
                onClick={handleFocus}
                style={intputStyle}
                InputProps={{...optionsInput.InputProps, disableUnderline: true, startAdornment: 'To'}}
            />
        </div>}

        <div className={classNames(style.sliderWrap)} style={wrapperStyle}>
            <Slider
                classes={{
                    root: classes.root,
                    markLabel: classNames(classes.markLabel, style.sliderMarkLabel),
                    mark: classes.mark,
                    track: classes.track,
                    thumb: classes.thumb,
                    markActive: classes.markActive,
                    markLabelActive: classes.markLabelActive,
                }}
                onChange={(e, value) => onChange(value)}
                getAriaValueText={valuetext}
                step={marks && Array.isArray(marks) ? null : step /* || marks[1].value */} // commented code was causing a crash
                min={marks && Array.isArray(marks) ? marks[0].value : min}
                max={marks && Array.isArray(marks) ? marks[marks.length - 1].value : max}
                value={val}
                marks={marks}
                style={{paddingTop: 10}}
            />
        </div>
    </React.Fragment>
    );
}

export function HenigSlider({ marks, min, max, step, value, onChange, inputs, optionsInput, wrapperStyle = {} }) {
    const classes = sliderStyles();

    const defaultMinVal = optionsInput && optionsInput.defaultValue;
    const defaultMaxVal = optionsInput && (optionsInput.defaultMaxValue || optionsInput.defaultValue);
    const [minVal, setMinVal] = React.useState(defaultMinVal)
    const [maxVal, setMaxVal] = React.useState(defaultMaxVal)
    const [val, setVal] = React.useState(value)

    React.useEffect(() => {
        setVal(value);
        setMinVal(value[0])
        setMaxVal(value[1])
    }, [value]);

    const updateMinValueFromInput = (minVal) => {
        if (!minVal) return minVal;
        minVal = parseFloat((minVal > defaultMinVal && minVal) || defaultMinVal);
        setMinVal(minVal);
        onChange([minVal, maxVal]);
    }

    const updateMaxValueFromInput = (maxVal) => {
        if (!maxVal) return maxVal;
        maxVal = parseFloat((maxVal < defaultMaxVal && maxVal) || defaultMaxVal);
        setMaxVal(maxVal);
        onChange([minVal, maxVal]);
    }

    const handleFocus = event => {
        event.preventDefault();
        const { target } = event;
        setTimeout(() => {
            target.focus();
            target.setSelectionRange(0, target.value.length);
        }, 200)
    }

    return (<React.Fragment>
        <div className={classNames(style.sliderWrap, inputs && classes.sliderWrapWithInputs)} style={wrapperStyle}>
            {inputs && <TextField
                classes={{ root: classNames(classes.sliderInput, style.sliderInput) }}
                size="small"
                {...optionsInput}
                value={minVal}
                onChange={e => updateMinValueFromInput(parseFloat(e.target.value))}
                onFocus={handleFocus}
                onClick={handleFocus}
            />}
            <Slider
                classes={{
                    root: classes.root,
                    markLabel: classNames(classes.markLabel, style.sliderMarkLabel),
                    mark: classes.mark,
                    track: classes.track,
                    thumb: classes.thumb,
                    markActive: classes.markActive,
                    markLabelActive: classes.markLabelActive,
                }}
                onChange={(e, value) => onChange(value)}
                getAriaValueText={valuetext}
                step={marks && Array.isArray(marks) ? null : step /* || marks[1].value */} // commented code was causing a crash
                min={marks && Array.isArray(marks) ? marks[0].value : min}
                max={marks && Array.isArray(marks) ? marks[marks.length - 1].value : max}
                value={val}
                marks={marks}
            />
            {inputs && <TextField
                classes={{ root: classNames(classes.sliderInput, style.sliderInput) }}
                size="small"
                {...optionsInput}
                value={maxVal}
                onChange={e => updateMaxValueFromInput(parseFloat(e.target.value))}
                onFocus={handleFocus}
                onClick={handleFocus}
            />}
        </div>
    </React.Fragment>
    );
}

const styles = theme => ({

});

const gradingLabs = ['GIA', 'IGI', 'IIDGR', 'HRD', 'EGL'];

class All extends PureComponent {
    state = {
        isStatePreloaded: false,
        isLoading: true,
        sideDrawerOpen: false,
        tabsValue: 0,
        docs: [],
        filteredItems: [],
        allItems: [],
        allSingles: [],
        allParcels: [],
        docsLength: 0,
        filterTab: 0,
        measurementsTab: 0,
        downloadItemsList: [],
        isMenuClosed: false,
        filters: false,
        page: 1, limit: 0, order: 'asc', orderBy: 'createdAt',
        isChecked: {
            // switch columns on for Single Item
            measurements: true,
            availability: true,
        },
        marksClarity: [],
        marksColour: [],

        dialogOpen: false,
        dialogOpenProps: {},
    }

    setDiamondsState(newState, next = () => { }){
        if(newState.filters){
            newState.openRowIndex = -1;
        }

        if(typeof newState.tabsValue !== 'number'){
            newState.tabsValue = this.state.tabsValue;
        }

        this.props.DiamondsActions.setDiamondsPageState(newState)
        this.setState(newState, () => next())
    }

    async componentDidMount() {
        const { selectAll = () => { }, diamondsData, width } = this.props;
        
        const isPC = ['xl', 'lg'].includes(width);
        
        let pageParam = this.props.match.params.page;
        let openLabGrown;

        if(pageParam === 'lab-grown'){
            pageParam = '';
            openLabGrown = true;
        }
        
        this.setState({limit: isPC ? 100 : 25, pageParam}, () => {
            selectAll();

            if (diamondsData) {
                this.loadFilters(diamondsData);
            }

            if (width === 'xs') {
                this.setDiamondsState({ isMenuClosed: true })
            }

            if(openLabGrown){
                setTimeout(() => {
                    this.onTabsChange({}, 1);
                }, 500);
            }
        })
    }

    componentDidUpdate(prevProps) {
        const { diamondsData } = this.props;
        if (diamondsData && diamondsData !== prevProps.diamondsData) {
            this.loadFilters(diamondsData);
        }
    }

    getDefaultSliders = (diamondsData, tabsValue, pageParam) => {
        if (!diamondsData) return {};
        const diamondsRanges = diamondsData.ranges;
        const marksClarity = diamondsData.marksClarity;
        const marksColour = diamondsData.marksColour;
        const StkCatType = tabsValue === 2 ? 'Multiple Items' : 'Single Item';

        let specialOffers = false;
        let shapes = [];

        if (pageParam) {
            if (pageParam === 'specials') {
                specialOffers = true;
            }
            if (pageParam !== 'specials') {
                shapes = [pageParam];
            }
        }

        return {
            weight: diamondsRanges.STWeight[StkCatType],
            clarity: [marksClarity[0].value, marksClarity[marksClarity.length - 1].value],
            colour: [marksColour[0].value, marksColour[marksColour.length - 1].value],
            price: [0, 100],
            ppc: [0, 100],
            shapes,
            gradingLabs: [],
            specialOffers,
            cut: [marksVotes[0].value, marksVotes[marksVotes.length - 1].value],
            polish: [marksVotes[0].value, marksVotes[marksVotes.length - 1].value],
            symmetry: [marksVotes[0].value, marksVotes[marksVotes.length - 1].value],
            fluorescence: [marksFluorescence[0].value, marksFluorescence[marksFluorescence.length - 1].value],
            depth: [0, 100],
            table: [0, 100],
            measurementsLength: diamondsRanges.StkMes1[StkCatType],
            measurementsWidth: diamondsRanges.StkMes2[StkCatType],
            measurementsDepth: diamondsRanges.StkMes3[StkCatType],
            search: '',
        }
    };

    getPageParam(){
        return this.state.pageParam;
    }

    loadFilters(diamondsData) {
        const { pageStateSingles, pageStateSinglesLab, pageStateParcels } = this.props;
        const { tabsValue } = this.state;
        const pageParam = this.getPageParam();

        const defaultSliders = this.getDefaultSliders(diamondsData, this.state.tabsValue, pageParam);

        let pageState = tabsValue === 0 ? pageStateSingles : tabsValue === 1 ? pageStateSinglesLab : tabsValue === 2 ? pageStateParcels : false;
        if(!pageState){
            pageState = {}
        }

        // disaled loading rows per page (limit) from cache because i think it's going to cause confusion when testing
        delete pageState.limit;

        // reset dowmload list on page load
        pageState.downloadItemsList = [];

        const newState = {
            marksClarity: diamondsData.marksClarity,
            marksColour: diamondsData.marksColour,
            filters: {
                shapes: defaultSliders.shapes,
                weight: defaultSliders.weight,
                clarity: defaultSliders.clarity,
                colour: defaultSliders.colour,
                price: defaultSliders.price,
                ppc: defaultSliders.ppc,
                gradingLabs: defaultSliders.gradingLabs,
                specialOffers: defaultSliders.specialOffers,
                cut: defaultSliders.cut,
                polish: defaultSliders.polish,
                symmetry: defaultSliders.symmetry,
                fluorescence: defaultSliders.fluorescence,
                depth: defaultSliders.depth,
                table: defaultSliders.table,
                measurementsLength: defaultSliders.measurementsLength,
                measurementsWidth: defaultSliders.measurementsWidth,
                measurementsDepth: defaultSliders.measurementsDepth,
                search: defaultSliders.search,
            },
            isStatePreloaded: true,
            ...pageState,
        };

        if (pageParam) {
            if (pageParam === 'specials') {
                newState.filters.specialOffers = true;
            }
            if (pageParam !== 'specials') {
                newState.filters.shapes = [pageParam]
                newState.filters.specialOffers = false;
            }
        }

        this.setState(newState, () => this.fetchDiamondsList())
    }

    openBag = (row) => {
        this.props.AuthActions.addToBag(row, () => {
            this.setDiamondsState({ sideDrawerOpen: 'bag', row });
        });
    };
    openPrice = () => {
        this.setDiamondsState({ sideDrawerOpen: 'price' });
    };
    toggleDownload = () => {
        const { isAuthorised, openEmailDialog } = this.props;

        if (!isAuthorised) {
            return openEmailDialog({ after: window.location.pathname })
        }

        const sideDrawerOpen = this.state.sideDrawerOpen !== 'download' ? 'download' : false;
        this.setDiamondsState({ sideDrawerOpen, isMenuClosed: sideDrawerOpen });
    };
    closeBag = () => {
        this.setDiamondsState({ sideDrawerOpen: false, isMenuClosed: false, row: false });
    };

    closeMobileBag = () => {
        this.setDiamondsState({ sideDrawerOpen: false, row: false });
    };

    onTabsChange = (e, tabsValue) => {
        const { diamondsData, pageStateSingles, pageStateSinglesLab, pageStateParcels } = this.props;
        const defaultSliders = this.getDefaultSliders(diamondsData, tabsValue, this.getPageParam());

        if(tabsValue === 1){
            this.props.history.push('/diamonds/all/lab-grown')
        }else{
            this.props.history.push('/diamonds/all')
        }

        const isChecked = _.mapValues(this.state.isChecked, () => false);
        isChecked.measurements = tabsValue === 2 ? true : false;
        isChecked.availability = (tabsValue === 0 || tabsValue === 1) ? true : false;

        let pageState = tabsValue === 0 ? pageStateSingles : tabsValue === 1 ? pageStateSinglesLab : tabsValue === 2 ? pageStateParcels : false;
        if(!pageState){
            pageState = {}
        }
        if(!pageState.filters){
            pageState.filters = defaultSliders;
        }
        if(!pageState.isChecked){
            pageState.isChecked = isChecked;
        }

        this.setDiamondsState({ ...pageState, tabsValue, page: 1, filterTab: 0 });
    };

    toggleFav(row, value) {
        const { favouriteItemsList } = this.props;
        this.props.DiamondsActions.setFavourite(value ? [...favouriteItemsList, row] : favouriteItemsList.filter(c => c._id !== row._id))
    }

    toggleDownloadItem(_id, value) {
        const { downloadItemsList } = this.state;
        this.setDiamondsState({
            downloadItemsList: value ? [...downloadItemsList, _id] : downloadItemsList.filter(c => c !== _id),
        });
    }

    toggleCompare(_id, value) {
        const { compareItemsList } = this.props;
        this.props.DiamondsActions.setCompare(value ? [...compareItemsList, _id] : compareItemsList.filter(c => c !== _id));
    }

    toggleFilter(key, value, skipSearchCheck) {
        const prevState = this.state;
        const { dialogSettings } = this.props;

        if(!skipSearchCheck && prevState.filters.search){
            if((!dialogSettings || (dialogSettings && !dialogSettings.resetSearch))){
                // ask user if wants to keep search
                return this.askUserAboutResettingSearch(key, value);
            }
            // if theres a user saved previous choice (in db) reset code or don't reset code - automatically.
            else if(dialogSettings.resetSearch){
                if(dialogSettings.resetSearch === 'yes'){
                    return this.resetFilters(() => {
                        this.toggleFilter(key, value, true);
                    }, 'search')
                }else if(dialogSettings.resetSearch === 'no'){
                    // comtinue below with the initiated search
                }
            }
        }

        const filters = {
            ...prevState.filters,
            [key]: prevState.filters[key].includes(value) ?
                prevState.filters[key].filter(s => s !== value) :
                [...prevState.filters[key], value]
        };

        this.setDiamondsState({
            filters,
            page: 1,
        }, () => this.fetchDiamondsList())
    }

    updateFilter(name, value, extraStateUpdates = {}, skipFiltersCheck) {
        const { dialogSettings } = this.props;
        const prevState = this.state;

        // only when using search 
        // only if there's a search value
        // only if there are any filters applied
        if(!skipFiltersCheck && name === 'search' && value && this.countChangedFilters()){
            // only if there is no user saved choice (db)
            // ask user about resetting filters?
            if((!dialogSettings || (dialogSettings && !dialogSettings.resetFilters))){
                // ask user if wants to keep filters
                return this.askUserAboutResettingFilters(value);
            }
            // if theres a user saved previous choice (in db) reset filters or don't reset filters - automatically.
            else if(dialogSettings.resetFilters){
                if(dialogSettings.resetFilters === 'yes'){
                    return this.resetFilters(() => {
                        this.updateFilter('search', value, {}, true);
                    })
                }else if(dialogSettings.resetFilters === 'no'){
                    // comtinue below with the initiated search
                }
            }
        }

        const filters = {
            ...prevState.filters,
        };
        filters[name] = value;

        this.setDiamondsState({
            filters,
            ...extraStateUpdates,
            page: 1,
        }, () => {
            this.fetchDiamondsList()
        })
    }

    onSubmit(data, action) {
        if (action === 'download') {
            this.onDownloadSubmit(data);
        }
    }

    onDownloadSubmit = async (data) => {
        const { isAuthorised, fxrates = [], ccy, diamond_available={} } = this.props;
        const { tabsValue } = this.state;

        let isParcelSelected = tabsValue === 2;

        this.setState({ isLoading: true })

        const titlesMap = {
            'current': 'Selected Stock',
            'selected': 'Selected Stock',
            'certified-rounds': 'Certified Rounds',
            'certified-fancies': 'Certified Fancies”',
            'certified-all': 'Certified Stock',
            'parcels': 'Parcel List',
        }

        let items = [];

        if (data.downloadType === 'current') {
            items = this.state.filteredItems;
        }
        if (data.downloadType === 'selected') {
            items = this.state.filteredItems.filter(row => this.state.downloadItemsList.includes(row._id));
        }
        if (data.downloadType === 'certified-rounds') {
            items = this.state.allSingles.filter(row => row.StkShape.toLowerCase() === 'round' && row.StkCertNo);
        }
        if (data.downloadType === 'certified-fancies') {
            items = this.state.allSingles.filter(row => row.StkShape.toLowerCase() !== 'round' && row.StkCertNo);
        }
        if (data.downloadType === 'certified-all') {
            items = this.state.allSingles.filter(row => row.StkCertNo);
        }
        if (data.downloadType === 'parcels') {
            items = this.state.allParcels;
            isParcelSelected = true;
        }

        const cutPolishAbbreviationsLevels = {
            'Excellent': 'EX',
            'Very Good': 'VG',
            'Good': 'GD',
            'Fair': 'FAR',
            'Poor': 'POR',
        };

        const fluorescenceAbbreviationLevels = {
            'None': 'NON',
            'Faint': 'FNT',
            'Slight': 'SL',
            'Very Slight': 'VSL',
            'Medium': 'MED',
            'Strong': 'SG',
            'Very Strong': 'VSG',
        }

        const widthMap = isParcelSelected
            ? [
                8 + 4,     // ID
                8 + 4,   // Shape
                6.3 + 6,    // Size
                5.3 + 4,      // Colour
                5.5 + 4,    // Clarity
                11.5 + 4,   // L/W/D
                13.5 + 4,   // Lab
                9 + 3,    // PPC
            ] : [
                7,     // ID
                8 - 0.8 + 0.5,   // Shape
                6.3 - 0.8 + 1,    // Weight
                5.3 - 0.8 + 0.3,      // Colour
                5.5 - 0.5 + 0.3,    // Clarity
                9.5 - 5,      // Cut
                5.3 - 0.8 + 0.3,      // Polish
                7 + 0.3,      // Symmetry
                5.3 - 0.8 + 0.3,      // Fluor
                11.5 + 1,   // L/W/D
                13.5 - 0.8 + 0.3,   // Lab
                9 - 0.8 + 0.3,    // PPC
                6.5 - 2 + 0.3,      // BR
                9.5 - 0.8 + 0.3,      // Price
            ];

        const selectedDownloadFormat = data && data.downloadType && data.downloadFormat;

        items = items.map(row => {
            const isParcel = row.StkCatType === 'Multiple Items' ? true : false;

            let ppc = '';
            let price = '';

            if (isParcel) {
                ppc = row.ppcOrig ? `${getSymbolFromCurrency(ccy)}${numeral(Math.round(convertToCurrency(row.ppcOrig, true, fxrates, ccy))).format('0,0.00')}` : '';
                price = `${getSymbolFromCurrency(ccy)}${numeral(Math.round(convertToCurrency(row.WebSpecial || row.ppc || row.ExWebTotal, true, fxrates, ccy))).format('0,0.00')}`;
            }
            if (!isParcel) {
                ppc = row.ppcOrig ? `${getSymbolFromCurrency(ccy)}${numeral(Math.round(convertToCurrency(row.priceOrig, false, fxrates, ccy)) / parseFloat(row.STWeight)).format('0,0.00')}` : '';
                price = `${getSymbolFromCurrency(ccy)}${numeral(Math.round(convertToCurrency(row.WebSpecial || row.price || row.ExWebTotal, false, fxrates, ccy))).format('0,0.00')}`;
            }

            const itemData = isParcelSelected ? [
                row.StkCodeCalcNS,
                row.StkShape,
                joinHenigArray(row, 'Size'),
                joinHenigArray(row, 'Colour'),
                joinHenigArray(row, 'Clarity'),
                row.Stk_Mes_Concat,
                `${row.StkCertSup}${row.StkCertNo ? '(' + row.StkCertNo + ')' : ''}`,
                ppc,
            ] : [
                row.StkCodeCalcNS,
                row.StkShape,
                numeral(row.STWeight).format('0.00') + ' ct',
                joinHenigArray(row, 'Colour'),
                joinHenigArray(row, 'Clarity'),
                selectedDownloadFormat === 'excel' ? joinHenigArray(row, 'Cut') : cutPolishAbbreviationsLevels[joinHenigArray(row, 'Cut')],
                selectedDownloadFormat === 'excel' ? parseHenigArray(row, 'Polish').join(' to ') : parseHenigArray(row, 'Polish').map(v => cutPolishAbbreviationsLevels[v]).join(' to '),
                selectedDownloadFormat === 'excel' ? parseHenigArray(row, 'Symmetry').join(' to ') : parseHenigArray(row, 'Symmetry').map(v => cutPolishAbbreviationsLevels[v]).join(' to '),
                selectedDownloadFormat === 'excel' ? parseHenigArray(row, 'flourecence').join(' to ') : parseHenigArray(row, 'flourecence').map(v => fluorescenceAbbreviationLevels[v]).join(' to '),
                row.Stk_Mes_Concat,
                `${row.StkCertSup}${row.StkCertNo ? '(' + row.StkCertNo + ')' : ''}`,
                ppc,
                `${row.RAP ? `%${row.RAP}` : ''}`,
                price,
            ]

            if(selectedDownloadFormat === 'excel'){
                if(row.availability === 1){
                    itemData.push(diamond_available['diamond_available_now'])
                }
                if(row.availability === 2){
                    itemData.push(diamond_available['diamond_available_later'])
                }
                if(row.availability === 3){
                    itemData.push(diamond_available['diamond_available_on_demand'])
                }
            }

            return itemData;
        });

        const filename = `HENIG DIAMONDS ${titlesMap[data.downloadType]} (Downloaded - ${moment().format('MMM Do YYYY')})`;
        let columns = isParcelSelected
            ? ['ID', 'Shape', 'Size', 'Colour', 'Clarity', 'L/W/D', 'Lab', 'PPC']
            : ['ID', 'Shape', 'Weight', 'Colour', 'Clarity', 'Cut', 'Polish', 'Symmetry', 'Fluor', 'L/W/D', 'Lab', 'PPC', 'BR', 'Price'];

        if (selectedDownloadFormat === "pdf") {

            setTimeout(async () => {
                const doc = <PDFDocument columns={columns} widthMap={widthMap} title={titlesMap[data.downloadType]} subTitle={`Downloaded - ${moment().format('MMM Do YYYY')}`} data={items} />;
                const asPdf = pdf([]);
                asPdf.updateContainer(doc);
                const blob = await asPdf.toBlob();
                saveAs(blob, `${filename}.pdf`);

                this.setState({ isLoading: false })

            }, 1000);
        }

        if (selectedDownloadFormat === 'excel') {
            const wb = new ExcelJS.Workbook()
            const ws = wb.addWorksheet()

            columns = [...columns, 'Availability']

            ws.columns = columns.map((col, i) => ({ header: col, key: `col${i}` }));

            ws.columns.forEach(column => {
                //column.width = column.header.length + 13;
                column.width = 20;
            })
        
            console.log('ws.columns', ws.columns)
            console.log('items', items)

            let headerRow = ws.getRow(1);
            headerRow.font = { bold: true };

            items.forEach(item => {
                ws.addRow(item);
            });

            const buf = await wb.xlsx.writeBuffer()

            saveAs(new Blob([buf]), `${filename}.xlsx`);

            this.setState({ isLoading: false })
        }

        /* <PDFViewer width="100%" height="100%" style={{ position: 'absolute', zIndex: 100000 }}>
            <PDFDocument title={'Selected Stock'} subTitle={'Downloaded - Jan 20th 2021'} data={[['79082', 'Marquise', '0.30 ct', 'D', 'VVS2', 'Very Good', 'Very Good', 'None', '5.48/3.75/2.35', 'GIA(2357735570)', '£988.62', '%24', '£333.66']]} />
        </PDFViewer> */
    }

    setPage(page) {
        this.setDiamondsState({ page }, () => this.fetchDiamondsList())
    }

    fetchDiamondsListFromTable = async (limit, order = 'asc', orderBy = 'createdAt') => {
        const { width } = this.props;
        const isPC = ['xl', 'lg'].includes(width);
        if(!limit){
            limit = isPC ? 100 : 25;
        }
        this.setDiamondsState({ limit, order, orderBy }, () => this.fetchDiamondsList())
    }

    fetchDiamondsList = async () => {
        let { page = 1, limit, order = 'asc', orderBy = 'createdAt', tabsValue, filters } = this.state;

        const { width } = this.props;
        const isPC = ['xl', 'lg'].includes(width);
        if(!limit){
            limit = isPC ? 100 : 25;
        }

        const { diamondsData, isAuthorised } = this.props;
        if (!filters || !diamondsData) return;

        const isSingleLabs = tabsValue === 1;
        const isParcel = tabsValue === 2;

        const defaultSliders = this.getDefaultSliders(diamondsData, tabsValue, this.getPageParam());

        this.setState({ isLoading: true })

        setTimeout(() => {

            const STWeight = filters.weight.map(s => parseFloat(s));
            const price = isAuthorised && filters.price.map(s => parseFloat(s));
            const ppc = isAuthorised && filters.ppc.map(s => parseFloat(s));
            const Clarity = filters.clarity.map(s => parseInt(s));
            const Colour = filters.colour.map(s => parseInt(s));
            const Cut = filters.cut.map(s => parseInt(s));
            const Polish = filters.polish.map(s => parseInt(s));
            const Symmetry = filters.symmetry.map(s => parseInt(s));
            const Fluorescence = filters.fluorescence.map(s => parseInt(s));
            const Depth = filters.depth.map(s => parseInt(s));
            const Table = filters.table.map(s => parseFloat(s));

            const MeasurementsLength = filters.measurementsLength.map(s => parseFloat(s));
            const MeasurementsWidth = filters.measurementsWidth.map(s => parseFloat(s));
            const MeasurementsDepth = filters.measurementsDepth.map(s => parseFloat(s));

            let i = 0;

            let allItems = diamondsData.docs.map(doc => ({
                ...doc,
                availability: doc.Availability || doc.StkWebAvailable,
                STWeight: doc.STWeight ? parseFloat(doc.STWeight) : 0,
                WebSpecial: doc.WebSpecial && doc.WebSpecial !== '0' ? parseFloat(doc.WebSpecial) : undefined,
                price: doc.price ? parseFloat(doc.price) : undefined,
                ppc: doc.ppc ? parseFloat(doc.ppc) : undefined,
                ExWebTotal: doc.ExWebTotal ? parseFloat(doc.ExWebTotal) : undefined,
                ppcOrig: doc.ppc,
                priceOrig: doc.price,
            }));


            function getSortValue(row, orderBy) {
                const isParcel = row.StkCatType === 'Multiple Items' ? true : false;

                if (i < 10) {
                    i++;
                }

                if (orderBy === 'weight') {
                    return parseFloat(row.STWeight);
                }
                if (orderBy === 'size') {
                    return row.Size && row.Size[0] && parseFloat(row.Size[0].From);
                }
                if (orderBy === 'colour') {
                    return row.Colour && row.Colour[0] && row.Colour[0].From;
                }
                if (orderBy === 'clarity') {
                    return row.Clarity && row.Clarity[0] && row.Clarity[0].From;
                }
                if (orderBy === 'Stk_Mes_Concat') {
                    return parseFloat(row.StkMes1);
                }
                if (orderBy === 'specialOffer') {
                    return row.WebSpecial ? 1 : 0;
                }

                return row[orderBy];
            }

            function descendingComparator(a, b, orderBy) {
                if (getSortValue(b, orderBy) < getSortValue(a, orderBy)) return -1;
                if (getSortValue(b, orderBy) > getSortValue(a, orderBy)) return 1;
                return 0;
            }

            function getComparator(order, orderBy) {
                return order === "desc" ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
            }

            function stableSort(array, comparator) {
                const stabilizedThis = array.map((el, index) => [el, index]);
                stabilizedThis.sort((a, b) => {
                    const order = comparator(a[0], b[0]);
                    if (order !== 0) return order;
                    return a[1] - b[1];
                });
                return stabilizedThis.map((el) => el[0]);
            }

            const allSingles = allItems.filter(i => i.StkCatType === 'Single Item' && ((isSingleLabs && i.Source === "Lab Grown") || (!isSingleLabs && i.StkCatName !== "Lab Grown Diamonds" && i.Source !== "Lab Grown")));
            const allParcels = allItems.filter(i => i.StkCatType === 'Multiple Items');
            this.setState({ allItems, allSingles, allParcels })

            const StkCatType = tabsValue === 2 ? 'Multiple Items' : 'Single Item';

            let items = StkCatType === 'Single Item' ? allSingles : allParcels;

            items = stableSort(items, getComparator(order, orderBy));

            if (filters.search) {
                items = items.filter(i => i.StkCodeCalcNS.toLowerCase().indexOf(filters.search.toLowerCase()) !== -1);
            }

            if (filters.shapes.length > 0) {
                items = items.filter(i => {
                    if (filters.shapes.includes('other')) {
                        return isOtherShape(isParcel, i.StkShape) || filters.shapes.includes(i.StkShape.toLowerCase())
                    }
                    return filters.shapes.includes(i.StkShape.toLowerCase())
                });
            }

            if (filters.gradingLabs.length > 0) {
                items = items.filter(i => filters.gradingLabs.includes(i.StkCertSup.toUpperCase()));
            }

            if (filters.specialOffers) {
                items = items.filter(i => i.WebSpecial && i.WebSpecial > 0);
            }

            if(this.getPageParam() === 'specials'){
                this.props.history.push('/diamonds/all')
            }

            if (!_.isEqual(STWeight, defaultSliders.weight)) {
                if(isParcel){
                    items = items.filter(doc => {
                        if(!(doc.Size && doc.Size[0] && doc.Size[1])) return false;

                        // find parcels within selected range
                        let displayItem =  doc.Size[0].From >= STWeight[0] && doc.Size[0].From <= STWeight[1] && 
                                           doc.Size[1].To <= STWeight[1] && doc.Size[1].To >= STWeight[0];
                        
                        // find parcels that contain selected range
                        if(!displayItem){
                            displayItem = STWeight[0] >= doc.Size[0].From && STWeight[1] <= doc.Size[1].To
                        }

                        return displayItem;
                    })
                }else{
                    items = items.filter(doc => {
                        return doc.STWeight >= STWeight[0] && doc.STWeight <= STWeight[1];
                    })
                }
            }

            if (!isParcel) {
                if (!_.isEqual(price, defaultSliders.price)) {
                    items = items.filter(doc => {
                        if (!isAuthorised) return true;
                        const priceVal = doc.WebSpecial || doc.price || doc.ExWebTotal;
                        const normalisedPrices = priceScale(price);
                        return priceVal >= normalisedPrices[0] && (price[1] === defaultSliders.price[1] || priceVal <= normalisedPrices[1]);
                    })
                }
            } else {
                if (!_.isEqual(ppc, defaultSliders.ppc)) {
                    items = items.filter(doc => {
                        if (!isAuthorised) return true;
                        const priceVal = doc.WebSpecial || doc.ppc || doc.ExWebTotal;
                        const normalisedPrices = priceScale(ppc);
                        return priceVal >= normalisedPrices[0] && (price[1] === defaultSliders.ppc[1] || priceVal <= normalisedPrices[1]);
                    })
                }
            }

            if (!_.isEqual(Clarity, defaultSliders.clarity)) {
                items = items.filter(doc => {
                    const clarity = parseInt(doc.Clarity[2].Array[0]);
                    return clarity >= Clarity[0] && (Clarity[1] < 9 ? clarity <= Clarity[1] : true);
                })
            }

            if (!_.isEqual(Colour, defaultSliders.colour)) {
                items = items.filter(doc => {
                    const colour = parseInt(doc.Colour[2].Array[0]);
                    return colour >= Colour[0] && colour <= Colour[1];
                })
            }

            if (!_.isEqual(Cut, defaultSliders.cut)) {
                items = items.filter(doc => {
                    if (!this.isSwitchChecked('cut')) return true;
                    const rawVal = doc.Cut[2].Array[0];
                    if (!rawVal) return false;
                    const cut = parseInt(rawVal);
                    return cut >= marksVotesMap[Cut[1]] && cut <= marksVotesMap[Cut[0]];
                })
            }

            if (!_.isEqual(Polish, defaultSliders.polish)) {
                items = items.filter(doc => {
                    if (!this.isSwitchChecked('polish')) return true;
                    const rawVal = doc.Polish[2].Array[0];
                    if (!rawVal) return false;
                    const polish = parseInt(rawVal);
                    return polish >= marksVotesMap[Polish[1]] && polish <= marksVotesMap[Polish[0]];
                })
            }

            if (!_.isEqual(Symmetry, defaultSliders.symmetry)) {
                items = items.filter(doc => {
                    if (!this.isSwitchChecked('symmetry')) return true;
                    const rawVal = doc.Symmetry[2].Array[0];
                    if (!rawVal) return false;
                    const symmetry = parseInt(rawVal);
                    return symmetry >= marksVotesMap[Symmetry[1]] && symmetry <= marksVotesMap[Symmetry[0]];
                })
            }

            if (!_.isEqual(Fluorescence, defaultSliders.fluorescence)) {
                items = items.filter(doc => {
                    if (!this.isSwitchChecked('fluorescence')) return true;
                    const rawVal = doc.flourecence[2].Array[0];
                    if (!rawVal) return false;
                    const fluorescence = parseInt(rawVal);
                    return fluorescence >= marksFluorescenceMap[Fluorescence[0]] && fluorescence <= marksFluorescenceMap[Fluorescence[1]];
                })
            }

            if (!_.isEqual(Depth, defaultSliders.depth)) {
                items = items.filter(doc => {
                    if (!this.isSwitchChecked('depth')) return true;
                    const depthPercent = parseFloat(doc.StkDepth_Total);
                    return depthPercent >= Depth[0] && depthPercent <= Depth[1];
                })
            }

            if (!_.isEqual(Table, defaultSliders.table)) {
                items = items.filter(doc => {
                    if (!this.isSwitchChecked('table')) return true;
                    const tablePercent = parseFloat(doc.StkTable);
                    return tablePercent >= Table[0] && tablePercent <= Table[1];
                })
            }

            items = items.filter(doc => {
                if (!this.isSwitchChecked('measurements')) return true;
                const StkMes1 = parseFloat(doc.StkMes1);
                const StkMes2 = parseFloat(doc.StkMes2);
                const StkMes3 = parseFloat(doc.StkMes3);

                return (StkMes1 >= MeasurementsLength[0] && StkMes1 <= MeasurementsLength[1] || _.isEqual(MeasurementsLength, defaultSliders.measurementsLength)) &&
                    (StkMes2 >= MeasurementsWidth[0] && StkMes2 <= MeasurementsWidth[1] || _.isEqual(MeasurementsWidth, defaultSliders.measurementsWidth)) &&
                    (StkMes3 >= MeasurementsDepth[0] && StkMes3 <= MeasurementsDepth[1] || _.isEqual(MeasurementsDepth, defaultSliders.measurementsDepth));
            });


            function paginate(array, page_size, page_number) {
                return array.slice((page_number - 1) * page_size, page_number * page_size);
            }

            // console.log('items', items)

            const docs = paginate(items, limit, page);

            this.setState({ docs: docs, docsLength: items.length, filteredItems: items, isLoading: false })
        }, 500)
    }

    isSwitchChecked(which) {
        return this.state.isChecked[which];
    }

    setSwitch(which, value) {
        const { diamondsData } = this.props;
        this.clearFilter(which)
        this.setDiamondsState({ isChecked: { ...this.state.isChecked, [which]: value } }, () => {

            // set focus to search bar if search switch is on:
            if (which === 'search' && value && this.searchRef) {
                this.searchRef.focus();
            }
        });
    }

    clearFilter(which) {
        const { diamondsData } = this.props;
        const defaultSliders = this.getDefaultSliders(diamondsData, this.state.tabsValue, this.getPageParam());
        if (which === 'measurements') {
            ['measurementsLength', 'measurementsWidth', 'measurementsDepth'].forEach(a => this.updateFilter(a, defaultSliders[a]))
        } else {
            this.updateFilter(which, defaultSliders[which])
        }
    }

    open360MessageDialog() {
        this.setDiamondsState({
            dialogOpen: "message",
            dialogOpenProps: {
                headline: ('Coming Soon'),
                description: '',
                onComplete: () => {
                    this.closeDialog();
                },
                hideBackButton: true,
            },
        });
    }

    async rememberFilterChoice(resetFilters){

        const settings = {
            settingName: 'resetFilters',
            settingValue: resetFilters ? 'yes' : 'no',
        }

        // update db by logged user
        const res = await api.patch(`/profile/updateDialogSettings`, settings);
        
        // load this value in this page so we don't ask the user about selected filters if the value is true
        this.props.AuthActions.checkAuth();
    }

    async rememberSearchChoice(resetSearch){

        const settings = {
            settingName: 'resetSearch',
            settingValue: resetSearch ? 'yes' : 'no',
        }

        // update db by logged user
        const res = await api.patch(`/profile/updateDialogSettings`, settings);
        
        // load this value in this page so we don't ask the user about selected filters if the value is true
        this.props.AuthActions.checkAuth();
    }
    
    askUserAboutResettingFilters(saerch) {
        const { isAuthorised, dialogSettingsFilterResetMessage } = this.props;
        this.setDiamondsState({
            dialogOpen: "message",
            dialogOpenProps: {
                headline: (`Reset Filters`),
                description: dialogSettingsFilterResetMessage || 'You are currently filtering the results. Do you want to reset the filter set?',
                content: ({ submitting, values }) => !isAuthorised ? '' : (<React.Fragment>
                    <Box display="flex" justifyContent="center" style={{margin: 0}}>
                        <CheckboxesSmallWrap>
                            <Checkboxes
                                name="rememberChoice"
                                data={[{ label: 'Remember my choice', value: 'y' }]}
                                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                checkedIcon={<CheckBoxIcon fontSize="small" />}
                            />
                        </CheckboxesSmallWrap>
                    </Box>
                </React.Fragment>),
                onComplete: (values) => {
                    if(values.rememberChoice && isAuthorised){
                        this.rememberFilterChoice(true)
                    }
                    // if yes, reset filters and then run search
                    this.resetFilters(() => {
                        this.closeDialog();
                        this.updateFilter('search', saerch, {}, true);
                    })
                },
                onBack: (data) => {
                    const values = data.values;
                    if(values.rememberChoice && isAuthorised){
                        this.rememberFilterChoice(false)
                    }
                    // if no just run search keeping filters
                    this.closeDialog();
                    this.updateFilter('search', saerch, {}, true);
                },
                submitLabel: 'Yes',
                backLabel: 'No',
            },
        });
    }

    askUserAboutResettingSearch(filter, value) {
        const { isAuthorised, dialogSettingsFilterResetMessage } = this.props;
        this.setDiamondsState({
            dialogOpen: "message",
            dialogOpenProps: {
                headline: (`Clear your code`),
                description: /* dialogSettingsFilterResetMessage || */ 'You are currently searching by code. Do you want to clear your code?',
                content: ({ submitting, values }) => !isAuthorised ? '' : (<React.Fragment>
                    <Box display="flex" justifyContent="center" style={{margin: 0}}>
                        <CheckboxesSmallWrap>
                            <Checkboxes
                                name="rememberChoice"
                                data={[{ label: 'Remember my choice', value: 'y' }]}
                                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                checkedIcon={<CheckBoxIcon fontSize="small" />}
                            />
                        </CheckboxesSmallWrap>
                    </Box>
                </React.Fragment>),
                onComplete: (values) => {
                    if(values.rememberChoice && isAuthorised){
                        this.rememberSearchChoice(true)
                    }
                    // if yes, reset filters and then run search
                    this.resetFilters(() => {
                        this.closeDialog();
                        this.toggleFilter(filter, value, true);
                    }, 'search')
                },
                onBack: (data) => {
                    const values = data.values;
                    if(values.rememberChoice && isAuthorised){
                        this.rememberSearchChoice(false)
                    }
                    // if no just run search keeping filters
                    this.closeDialog();
                    this.toggleFilter(filter, value, true);
                },
                submitLabel: 'Yes',
                backLabel: 'No',
            },
        });
    }

    closeDialog = () => {
        this.setDiamondsState({ dialogOpen: null });
    };

    countChangedFilters(){
        const { diamondsData } = this.props;
        const { tabsValue, filters } = this.state;

        const defaultSliders = this.getDefaultSliders(diamondsData, tabsValue, this.getPageParam());

        let changedFilters = 0;
        for(let f in filters){
            if(!_.isEqual(filters[f], defaultSliders[f])){
                changedFilters++
            }
        }

        return changedFilters;
    }

    resetFilters(next = () => {}, whichKeyToResetOnly=false){
        const { diamondsData } = this.props;
        const { tabsValue, filters } = this.state;
        const defaultSliders = this.getDefaultSliders(diamondsData, tabsValue, this.getPageParam());
        if(whichKeyToResetOnly){
            const newFilters = {...filters}
            newFilters[whichKeyToResetOnly] = defaultSliders[whichKeyToResetOnly];
            this.setDiamondsState({ filters: {...newFilters} }, () => next())
        }else{
            this.setDiamondsState({ filters: {...defaultSliders} }, () => next())
        }
    }

    clearAll(){
        this.resetFilters(() => {
            this.updateFilter('search', '')
        })
    }

    render() {
        const {
            sideDrawerOpen,
            tabsValue,
            docs = [],
            docsLength,
            filterTab,
            downloadItemsList = [],
            row,
            page = 1, limit, order, orderBy,
            filters,
            isLoading,
            marksClarity = [],
            marksColour = [],
            dialogOpen,
            dialogOpenProps,
            isStatePreloaded,
        } = this.state;
        const {
            isAuthorised,
            diamondsData,
            compareItemsList = [],
            favouriteItemsList = [],
            ccy,
            fxrates = [],
            diamond_available = {},
            openEmailDialog,
            areDiamondsLoading,
            width,
        } = this.props;

        const defaultSliders = this.getDefaultSliders(diamondsData, tabsValue, this.getPageParam());

        const isMobile = width === 'xs';
        const isPC = ['xl', 'lg'].includes(width);

        return (<div className={style.wrapper}>

            {dialogOpen === 'message' &&
                <MessageDialog
                    onClose={this.closeDialog}
                    {...dialogOpenProps}
                />
            }

            <div className={style.inner}>

                <div className={style.innerColumns}>

                    <div className={classNames(style.sideMenu, this.state.isMenuClosed && style.closed)} style={isMobile && this.state.isMenuClosed ? { display: 'none' } : {}}>

                        {isMobile && <div style={{ 
                            padding: '15px',
                            marginBottom: '2px',
                            borderBottom: '1px solid rgb(176 143 110 / 30%)',
                            paddingTop: '0',
                            marginTop: '-12px',
                         }}>
                            {!this.state.isMenuClosed && <HideTrengoChat />}
                            <Button size="small" style={{color: 'white', border: '1px solid rgb(176, 143, 110)'}} variant="outlined" onClick={() => this.setDiamondsState({ isMenuClosed: true })}>View Results</Button>
                        </div>}


                        {filters && <React.Fragment>
                            {!isMobile &&
                                <Tooltip title={this.state.isMenuClosed ? 'Expand Menu' : 'Collapse Menu'} placement="right">
                                    <div className={classNames(style.toggleMenuButton, this.state.isMenuClosed && style.closed)} onClick={() => this.setDiamondsState({ isMenuClosed: !this.state.isMenuClosed })}><ArrowBackIosIcon /></div>
                                </Tooltip>
                            }

                            {this.state.isMenuClosed && <div className={classNames(style.filterRow, style.minimisedMenu)}>
                                <p onClick={() => this.setDiamondsState({ isMenuClosed: false })}><img alt="" src="/images/filters.svg" /></p>

                                <Tooltip title={'Clear Filters'} placement="right">
                                    <p onClick={() => this.resetFilters()}><img alt="" src={`/images/clear${!_.isEqual(filters, defaultSliders) ? '-icon' : ''}.svg`} /></p>
                                </Tooltip>

                            </div>}

                            <div style={{ display: !this.state.isMenuClosed ? 'flex' : 'none', height: '100%', flexDirection: 'column' }}>

                                <div className={style.topButtons}>
                                    <div className={style.topButtons} style={{
                                            border: '1px solid #8d9298',
                                        }}>
                                        <Button style={{
                                            borderBottom: filterTab === 0 && '3px solid #b08f6e',
                                            width: 123,
                                            borderRight: '1px solid #8d9298',
                                            borderRadius: 0
                                        }} className={(filterTab === 0 && style.active) || undefined} onClick={() => this.setDiamondsState({ filterTab: 0 })}>Filters ({this.countChangedFilters()})</Button>
                                        <Button style={{
                                            borderBottom: filterTab === 1 && '3px solid #b08f6e',
                                            width: 123,
                                            borderRadius: 0
                                        }} className={(filterTab === 1 && style.active) || undefined} onClick={() => this.setDiamondsState({ filterTab: 1 })}>More Filters</Button>
                                    </div>
                                    <Button onClick={() => this.clearAll()}><img alt="" src="/images/clear.svg" /> <span>Clear All</span></Button>
                                </div>

                                <div style={{ display: filterTab === 0 ? 'flex' : 'none', flexDirection: 'column', gap: 15, paddingTop: 15 }}>
                                    <div className={style.filterRow}>
                                        <h3>
                                            Shape
                                        <small onClick={() => this.clearFilter('shapes')}>Clear</small>
                                        </h3>

                                        <div className={style.diamondShapes}>
                                            {((tabsValue === 0 || tabsValue === 1) ? shapesSingle : tabsValue === 2 ? shapesParcels : []).map(s => <div key={s.label} className={(filters.shapes.includes(s.value) && style.active) || undefined} onClick={() => this.toggleFilter('shapes', s.value)}>
                                                {!['other'].includes(s.value) && <React.Fragment>
                                                    <img alt="" src={`/images/${s.value.indexOf('old cut') !== -1 ? 'round' : s.value}.svg`} />
                                                    <p>{s.label}</p>
                                                </React.Fragment>
                                                }
                                                {['other'].includes(s.value) && <p className={style.textOnly}>{s.label}</p>}
                                            </div>)}
                                        </div>
                                    </div>

                                    <div className={style.filterRow}>
                                        <h3>
                                            Weight
                                            <small onClick={() => this.clearFilter('weight')}>Clear</small>
                                        </h3>
                                        <HenigSliderLarge value={filters.weight} onChange={(value) => this.updateFilter('weight', value)} step={0.01} min={defaultSliders.weight[0]} max={defaultSliders.weight[1]} inputs={true} optionsInput={optionsInputCarats(defaultSliders.weight)} />
                                    </div>

                                    <div className={style.filterRow}>
                                        <h3>
                                            Colour
                                            <small onClick={() => this.clearFilter('colour')}>Clear</small>
                                        </h3>
                                        <HenigSlider value={filters.colour} onChange={(value) => this.updateFilter('colour', value)} marks={marksColour} />
                                    </div>

                                    <div className={style.filterRow}>
                                        <h3>
                                            Clarity
                                            <small onClick={() => this.clearFilter('clarity')}>Clear</small>
                                        </h3>
                                        <HenigSlider value={filters.clarity} onChange={(value) => this.updateFilter('clarity', value)} marks={marksClarity} />
                                    </div>

                                    {(tabsValue === 0 || tabsValue === 1) &&
                                        <div className={style.filterRow}>
                                            <h3>
                                                Grading Lab
                                            <small onClick={() => this.clearFilter('gradingLabs')}>Clear</small>
                                            </h3>
                                            <div className={style.gradingLabs}>
                                                {gradingLabs.map(lab => <div key={lab} className={(filters.gradingLabs.includes(lab) && style.active) || undefined} onClick={() => this.toggleFilter('gradingLabs', lab)}>{lab}</div>)}
                                            </div>
                                        </div>
                                    }

                                    {isAuthorised && (tabsValue === 0 || tabsValue === 1) &&
                                        <div className={style.filterRow}>
                                            <h3>
                                                Price
                                            <small onClick={() => this.clearFilter('price')}>Clear</small>
                                            </h3>
                                            <HenigSliderPrice value={filters.price} onChange={(value) => this.updateFilter('price', value)} ccy={ccy} />
                                        </div>
                                    }

                                    {isAuthorised && tabsValue === 2 &&
                                        <div className={style.filterRow}>
                                            <h3>
                                                Price per carat
                                            <small onClick={() => this.clearFilter('ppc')}>Clear</small>
                                            </h3>
                                            <HenigSliderPrice value={filters.ppc} onChange={(value) => this.updateFilter('ppc', value)} ccy={ccy} />
                                        </div>
                                    }

                                    <div className={style.filterRow}>
                                        <div style={{ marginTop: 24, display: 'flex' }}>
                                            <FormControlLabel
                                                classes={{ root: style.checkboxRoot }}
                                                control={<Checkbox checked={filters.specialOffers} onChange={(e, value) => this.updateFilter('specialOffers', value)} icon={<RadioButtonUncheckedOutlinedIcon style={{ color: '#8d9298', opacity: 0.2 }} />} checkedIcon={<CheckCircleIcon style={{ color: '#b08f6e' }} />} name="checkedH" />}
                                                label="SPECIAL OFFERS"
                                            />
                                        </div>

                                    </div> 
                                </div>

                                {/* Advanced Filters */}
                                <div style={{ display: filterTab === 1 ? 'flex' : 'none', flexDirection: 'column', gap: 15, paddingTop: 15 }}>

                                    {isAuthorised && <div className={style.filterRow}>
                                        <div className={style.filterRowInline}>
                                            <h3>
                                                AVAILABILITY
                                            </h3>
                                            {filterTab === 1 &&
                                                <FormControlLabel
                                                    value="start"
                                                    control={<Switch size="small" color="primary" checked={this.isSwitchChecked('availability')} onChange={(e, value) => this.setSwitch('availability', value)} />}
                                                    label="Add To Table"
                                                    labelPlacement="start"
                                                />
                                            }
                                        </div>
                                        <hr />
                                    </div>}

                                    {(tabsValue === 0 || tabsValue === 1) && <React.Fragment>
                                        <div className={style.filterRow}>
                                            <div className={style.filterRowInline}>
                                                <h3>
                                                    CUT
                                                </h3>
                                                {filterTab === 1 &&
                                                    <FormControlLabel
                                                        value="start"
                                                        control={<Switch size="small" color="primary" checked={this.isSwitchChecked('cut')} onChange={(e, value) => this.setSwitch('cut', value)} />}
                                                        label="Add To Table"
                                                        labelPlacement="start"
                                                    />
                                                }
                                            </div>
                                            {this.isSwitchChecked('cut') && <HenigSlider value={filters.cut} onChange={(value) => this.updateFilter('cut', value)} marks={marksVotes} />}
                                            <hr />
                                        </div>
                                        <div className={style.filterRow}>
                                            <div className={style.filterRowInline}>
                                                <h3>
                                                    POLISH
                                            </h3>
                                                {filterTab === 1 &&
                                                    <FormControlLabel
                                                        value="start"
                                                        control={<Switch size="small" color="primary" checked={this.isSwitchChecked('polish')} onChange={(e, value) => this.setSwitch('polish', value)} />}
                                                        label="Add To Table"
                                                        labelPlacement="start"
                                                    />
                                                }
                                            </div>
                                            {this.isSwitchChecked('polish') && <HenigSlider value={filters.polish} onChange={(value) => this.updateFilter('polish', value)} marks={marksVotes} />}
                                            <hr />
                                        </div>
                                        <div className={style.filterRow}>
                                            <div className={style.filterRowInline}>
                                                <h3>
                                                    SYMMETRY
                                            </h3>
                                                {filterTab === 1 &&
                                                    <FormControlLabel
                                                        value="start"
                                                        control={<Switch size="small" color="primary" checked={this.isSwitchChecked('symmetry')} onChange={(e, value) => this.setSwitch('symmetry', value)} />}
                                                        label="Add To Table"
                                                        labelPlacement="start"
                                                    />
                                                }
                                            </div>
                                            {this.isSwitchChecked('symmetry') && <HenigSlider value={filters.symmetry} onChange={(value) => this.updateFilter('symmetry', value)} marks={marksVotes} />}
                                            <hr />
                                        </div>
                                        <div className={style.filterRow}>
                                            <div className={style.filterRowInline}>
                                                <h3>
                                                    FLUORESCENCE
                                                </h3>
                                                {filterTab === 1 &&
                                                    <FormControlLabel
                                                        value="start"
                                                        control={<Switch size="small" color="primary" checked={this.isSwitchChecked('fluorescence')} onChange={(e, value) => this.setSwitch('fluorescence', value)} />}
                                                        label="Add To Table"
                                                        labelPlacement="start"
                                                    />
                                                }
                                            </div>
                                            {this.isSwitchChecked('fluorescence') && <HenigSlider value={filters.fluorescence} onChange={(value) => this.updateFilter('fluorescence', value)} marks={marksFluorescence} />}
                                            <hr />
                                        </div>
                                        <div className={style.filterRow}>
                                            <div className={style.filterRowInline}>
                                                <h3>
                                                    DEPTH
                                                </h3>
                                                <FormControlLabel
                                                    value="start"
                                                    control={<Switch size="small" color="primary" checked={this.isSwitchChecked('depth')} onChange={(e, value) => this.setSwitch('depth', value)} />}
                                                    label="Add To Table"
                                                    labelPlacement="start"
                                                />
                                            </div>
                                            {this.isSwitchChecked('depth') && <HenigSlider value={filters.depth} onChange={(value) => this.updateFilter('depth', value)} step={1} min={1} max={100} inputs={true} optionsInput={optionsInputPercentage} />}
                                            <hr />
                                        </div>
                                        <div className={style.filterRow}>
                                            <div className={style.filterRowInline}>
                                                <h3>
                                                    TABLE
                                            </h3>
                                                {filterTab === 1 &&
                                                    <FormControlLabel
                                                        value="start"
                                                        control={<Switch size="small" color="primary" checked={this.isSwitchChecked('table')} onChange={(e, value) => this.setSwitch('table', value)} />}
                                                        label="Add To Table"
                                                        labelPlacement="start"
                                                    />
                                                }
                                            </div>
                                            {this.isSwitchChecked('table') && <HenigSlider value={filters.table} onChange={(value) => this.updateFilter('table', value)} step={1} min={0} max={100} inputs={true} optionsInput={optionsInputPercentage} />}
                                            <hr />
                                        </div>
                                    </React.Fragment>}


                                    <div className={style.filterRow}>
                                        <div className={style.filterRowInline}>
                                            <h3>
                                                MEASUREMENTS
                                            </h3>
                                            {filterTab === 1 &&
                                                <FormControlLabel
                                                    value="start"
                                                    control={<Switch size="small" color="primary" checked={this.isSwitchChecked('measurements')} onChange={(e, value) => this.setSwitch('measurements', value)} />}
                                                    label="Add To Table"
                                                    labelPlacement="start"
                                                />
                                            }
                                        </div>

                                        {this.isSwitchChecked('measurements') && <React.Fragment>
                                            <div className={style.measurementsSwitch}>
                                                <div className={this.state.measurementsTab === 0 && style.active} onClick={() => this.setDiamondsState({ measurementsTab: 0 })}>Length</div>
                                                <div className={this.state.measurementsTab === 1 && style.active} onClick={() => this.setDiamondsState({ measurementsTab: 1 })}>Width</div>
                                                {(tabsValue === 0 || tabsValue === 1) && <div className={this.state.measurementsTab === 2 && style.active} onClick={() => this.setDiamondsState({ measurementsTab: 2 })}>Depth</div>}
                                            </div>
                                            <HenigSlider wrapperStyle={{ display: this.state.measurementsTab === 0 ? 'flex' : 'none' }} value={filters.measurementsLength} onChange={(value) => this.updateFilter('measurementsLength', value)} step={0.01} min={defaultSliders.measurementsLength[0]} max={defaultSliders.measurementsLength[1]} inputs={true} optionsInput={optionsInputMeasurements(defaultSliders.measurementsLength)} />
                                            <HenigSlider wrapperStyle={{ display: this.state.measurementsTab === 1 ? 'flex' : 'none' }} value={filters.measurementsWidth} onChange={(value) => this.updateFilter('measurementsWidth', value)} step={0.01} min={defaultSliders.measurementsWidth[0]} max={defaultSliders.measurementsWidth[1]} inputs={true} optionsInput={optionsInputMeasurements(defaultSliders.measurementsWidth)} />
                                            <HenigSlider wrapperStyle={{ display: this.state.measurementsTab === 2 ? 'flex' : 'none' }} value={filters.measurementsDepth} onChange={(value) => this.updateFilter('measurementsDepth', value)} step={0.01} min={defaultSliders.measurementsDepth[0]} max={defaultSliders.measurementsDepth[1]} inputs={true} optionsInput={optionsInputMeasurements(defaultSliders.measurementsDepth)} />
                                        </React.Fragment>}
                                        <hr />
                                    </div>

                                    {(tabsValue === 0 || tabsValue === 1) && <React.Fragment>
                                        <div className={style.filterRow}>
                                            <div className={style.filterRowInline}>
                                                <h3>
                                                    LENGTH / WIDTH RATIO
                                        </h3>
                                                {filterTab === 1 &&
                                                    <FormControlLabel
                                                        value="start"
                                                        control={<Switch size="small" color="primary" checked={this.isSwitchChecked('lengthWidthRatio')} onChange={(e, value) => this.setSwitch('lengthWidthRatio', value)} />}
                                                        label="Add To Table"
                                                        labelPlacement="start"
                                                    />
                                                }
                                            </div>
                                            <hr />
                                        </div>
                                        {isAuthorised &&
                                            <div className={style.filterRow}>
                                                <div className={style.filterRowInline}>
                                                    <h3>
                                                        {(tabsValue === 0 || tabsValue === 1) && <span>RAP BELOW</span>}
                                                        {tabsValue === 2 && <span>RAP</span>}
                                                    </h3>
                                                    {filterTab === 1 &&
                                                        <FormControlLabel
                                                            value="start"
                                                            control={<Switch size="small" color="primary" checked={this.isSwitchChecked('rap')} onChange={(e, value) => this.setSwitch('rap', value)} />}
                                                            label="Add To Table"
                                                            labelPlacement="start"
                                                        />
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </React.Fragment>}

                                    {tabsValue === 2 && <React.Fragment>
                                        <div className={style.filterRow}>
                                            <div className={style.filterRowInline}>
                                                <h3>
                                                    Sieve Plate
                                                </h3>
                                                {filterTab === 1 &&
                                                    <FormControlLabel
                                                        value="start"
                                                        control={<Switch size="small" color="primary" checked={this.isSwitchChecked('sieve')} onChange={(e, value) => this.setSwitch('sieve', value)} />}
                                                        label="Add To Table"
                                                        labelPlacement="start"
                                                    />
                                                }
                                            </div>
                                            <hr />
                                        </div>
                                    </React.Fragment>}
                                </div>

                            </div>
                        </React.Fragment>}

                    </div>

                    <div className={classNames(style.sidePage, 'dark-support')} style={{ flex: sideDrawerOpen === 'download' ? this.state.isMenuClosed ? '0 0 calc(100% - 106px)' : '0 0 calc(100% - 376px)' : '1' }}>
                        <div className={style.secondaryNavWrap}>
                            <SecondaryNav
                                value="all"
                                openDiamondSideDrawer={sideDrawerOpen}
                                closeBag={!isMobile ? this.closeBag : this.closeMobileBag}
                                onSubmit={(data, action) => this.onSubmit(data, action)}
                                sideDrawerProps={{ row, isLoading }}
                                onMobileFiltersClick={() => this.setDiamondsState({ isMenuClosed: false })}
                            />
                        </div>

                        <div>
                            <SingleAndParcelsTabs
                                value={tabsValue}
                                onChange={this.onTabsChange}
                                appBarStyle={{ width: !isMobile ? '50%' : 'auto', float: 'left', borderBottom: 'none' }}
                                hideLinearProgress
                                showColourDiamonds
                            />

                            {isMobile && <TableHeadCellActions
                                wrapStyle={{ float: 'right', width: 'auto', marginTop: 12, gap: 5 }}
                                onDownloadClick={() => this.toggleDownload()}
                                isDownloadView={sideDrawerOpen === 'download'}
                                isSearchView={this.isSwitchChecked('search')}
                                onSearchClick={() => {
                                    this.setSwitch('search', !this.isSwitchChecked('search'))
                                }}
                                isMobile={isMobile}
                            />}

                            {this.isSwitchChecked('search') &&
                                <StyledSearchBar
                                    ref={el => this.searchRef = el}
                                    placeholder={'Search by code'}
                                    onChange={(newValue) => {
                                        clearTimeout(this.searchTyping);
                                        this.searchTyping = setTimeout(() => {
                                            this.updateFilter('search', newValue)
                                        }, 1000)
                                    }}
                                    onRequestSearch={(newValue) => this.updateFilter('search', newValue)}
                                    onCancelSearch={() => this.updateFilter('search', '')}
                                    value={filters.search}
                                    cancelOnEscape
                                    onKeyDown={e => e.keyCode === 27 && this.setSwitch('search', !this.isSwitchChecked('search'))}
                                    style={isMobile ? { width: '100%', marginTop: 16, marginBottom: 10 } : {}}
                                />
                            }
                            {!this.isSwitchChecked('search') && !isMobile &&
                                <div style={{ float: 'right', marginTop: 16 }}>
                                    <Tooltip title={'Search'} placement="top">
                                        <IconButton size="small" onClick={() => this.setSwitch('search', !this.isSwitchChecked('search'))}>
                                            <img width={22} alt="" src={`/images/search${this.isSwitchChecked('search') ? '_active' : ''}.svg`} style={{ filter: this.isSwitchChecked('search') && 'brightness(0)' }} />
                                        </IconButton>
                                    </Tooltip>
                                </div>
                            }
                            <div style={{ clear: 'both' }}></div>
                            <StyledLinearProgress show={areDiamondsLoading || isLoading} style={{ marginBottom: 0, marginTop: 1 }} />
                        </div>

                        {((tabsValue === 0 || tabsValue === 1) || (tabsValue === 2 && isAuthorised)) && isStatePreloaded && <div className={style.allItemsListTable}>
                            <EnhancedTable
                                ccy={ccy}
                                fxrates={fxrates}
                                isLoading={isLoading}
                                columnsSetup={headCells({
                                    diamond_available,
                                    ccy,
                                    fxrates,
                                    isParcel: tabsValue === 2,
                                    isAuthorised,
                                    showExtraColumns: {
                                        availability: this.isSwitchChecked('availability'),
                                        cut: this.isSwitchChecked('cut'),
                                        polish: this.isSwitchChecked('polish'),
                                        symmetry: this.isSwitchChecked('symmetry'),
                                        fluorescence: this.isSwitchChecked('fluorescence'),
                                        depth: this.isSwitchChecked('depth'),
                                        table: this.isSwitchChecked('table'),
                                        measurements: this.isSwitchChecked('measurements'),
                                        lengthWidthRatio: this.isSwitchChecked('lengthWidthRatio'),
                                        rap: this.isSwitchChecked('rap'),
                                        sieve: this.isSwitchChecked('sieve'),
                                    },
                                    isMobile
                                })}
                                tabsValue={tabsValue}
                                isParcel={tabsValue === 2}
                                fetchDiamondsList={this.fetchDiamondsListFromTable}
                                isAuthorised={isAuthorised}
                                openBag={this.openBag}
                                docs={docs}
                                docsLength={docsLength}
                                favouriteItemsList={favouriteItemsList}
                                compareItemsList={compareItemsList}
                                toggleFav={(row, value) => this.toggleFav(row, value)}
                                toggleCompare={(_id, value) => this.toggleCompare(_id, value)}

                                // download items
                                onDownloadClick={() => this.toggleDownload()}
                                isDownloadView={sideDrawerOpen === 'download'}
                                downloadItemsList={downloadItemsList}
                                toggleDownloadItem={(_id, value) => this.toggleDownloadItem(_id, value)}

                                isSearchView={this.isSwitchChecked('search')}
                                onSearchClick={() => {
                                    this.setSwitch('search', !this.isSwitchChecked('search'))
                                }}
                                search={filters.search}
                                onSearchChange={value => this.updateFilter('search', value)}

                                page={page}
                                limit={limit}
                                order={order}
                                orderBy={orderBy}
                                setPage={page => this.setPage(page)}
                                anyFiltersInUse={!_.isEqual(filters, defaultSliders)}
                                open360MessageDialog={() => this.open360MessageDialog()}
                                openEmailDialog={openEmailDialog}
                                isMobile={isMobile}
                                isPC={isPC}

                                openRowIndex={this.state.openRowIndex}
                                setOpenRowIndex={value => this.setDiamondsState({openRowIndex: value})}
                            />
                        </div>
                        }


                        {tabsValue === 2 && !isAuthorised && <div className={style.parcelsLoggedOutPlaceholder} onClick={() => openEmailDialog({ after: window.location.pathname })}>
                            {/* <div className={style.emptyListMsg}>
                                <h2>Please Login To See Our Parcels</h2>
                                <br />
                                <Button
                                    type="button"
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => openEmailDialog({ after: window.location.pathname })}
                                >
                                    Login
                                </Button>
                            </div>
                            <br /> */}
                            <img src="/images/Parcels Login_Register.png" alt="" />
                        </div>}

                        {tabsValue === 3 && <div className={style.colourDiamondsPlaceholder}>
                            {/* 
                            <div className={style.emptyListMsg}>
                                <h2>Coming Soon...</h2>
                            </div>
                            */}
                            <img src="/images/Coloured -Comming Soon - Light Version.png" alt="" />
                        </div>}
                    </div>
                </div>


            </div>

        </div >);
    }
}

All.propTypes = {
    selectAll: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    width: PropTypes.string.isRequired,
};

export default connect(
    (state) => ({
        dialogSettings: state.auth && state.auth.user && state.auth.user.dialogSettings,
        dialogSettingsFilterResetMessage: state.site.dialogSettings && state.site.dialogSettings.filterResetMessage,
        isAuthorised: state.auth.isAuthorised,
        diamondsData: state.diamonds.data,
        compareItemsList: state.diamonds.compare,
        favouriteItemsList: state.diamonds.favourite,
        ccy: state.site.ccy,
        fxrates: state.site.fxrates,
        diamond_available: state.site.diamond_available,
        areDiamondsLoading: !state.diamonds || !state.diamonds.data || !state.diamonds.data.docs || !state.diamonds.data.docs.length,
        pageStateSingles: state.diamonds.pageStateSingles,
        pageStateSinglesLab: state.diamonds.pageStateSinglesLab,
        pageStateParcels: state.diamonds.pageStateParcels,
    }),
    (dispatch) => ({
        AuthActions: bindActionCreators({ ...AuthActions }, dispatch),
        DiamondsActions: bindActionCreators({ ...DiamondsActions }, dispatch),
    })
)(withWidth()(withStyles(styles, { withTheme: true })(All)));
